/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (e) {
    const title = e.target.closest('.collapsible-row-title-wrapper');
    if (!title) return;

    const container = title.closest('.collapsible-row-container');

    if (container.classList.contains('active')) {
      container.classList.remove('active');
    }else{
      document.querySelectorAll('.collapsible-row-container').forEach(container => {
        container.classList.remove('active');
      });

      if (container) {
        container.classList.add('active');
      }
    }
  });

  document.querySelectorAll('.before-after-wrapper').forEach(wrapper => {
    const resizer = wrapper.querySelector('.resizer_wrapper');
    const beforeImg = wrapper.querySelector('.before-img');

    let isDragging = false;
    let dragStarted = false;

    const setTransition = (enabled) => {
      const transitionValue = enabled ? '0.5s ease-in-out' : 'none';
      resizer.style.transition = `left ${transitionValue}`;
      beforeImg.style.transition = `clip-path ${transitionValue}`;
    };

    const startDrag = (e) => {
      isDragging = true;
      dragStarted = true;
      setTransition(false); 
      e.preventDefault();
    };

    const endDrag = () => {
      isDragging = false;
      setTimeout(() => {
        dragStarted = false;
      }, 50);
    };

    const moveSlider = (clientX) => {
      beforeImg.classList.remove('active');
      resizer.classList.remove('active');
      const rect = wrapper.getBoundingClientRect();
      const offsetX = clientX - rect.left;
      const percent = Math.max(0, Math.min(100, (offsetX / wrapper.offsetWidth) * 100));
      resizer.style.left = `${percent}%`;
      beforeImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    };

    resizer.addEventListener('mousedown', startDrag);
    resizer.addEventListener('touchstart', startDrag);

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);

    document.addEventListener('mousemove', (e) => {
      if (isDragging) moveSlider(e.clientX);
    });

    document.addEventListener('touchmove', (e) => {
      if (isDragging) moveSlider(e.touches[0].clientX);
    });

    beforeImg.addEventListener('click', (e) => {
      if (dragStarted) return;
      beforeImg.classList.add('active');
      resizer.classList.add('active');
      setTransition(true);
      resizer.style.left = `93%`;
      beforeImg.style.clipPath = `inset(0 7% 0 0)`;
    });

    wrapper.addEventListener('click', (e) => {
      if (dragStarted || beforeImg.contains(e.target)) return;
      beforeImg.classList.add('active');
      resizer.classList.add('active');
      setTransition(true);
      resizer.style.left = `7%`;
      beforeImg.style.clipPath = `inset(0 93% 0 0)`;
    });
  });

  const loadMoreBtn = document.querySelector('.js-load-more');
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', function () {
    const totalPages = parseInt(document.querySelector('[data-total-pages]').value, 10);
    const currentPageInput = document.querySelector('[data-current-page]');
    const nextUrlInput = document.querySelector('[data-next-url]');
    const currentPage = parseInt(currentPageInput.value, 10);
    const nextPage = currentPage + 1;

    loadMoreBtn.disabled = true;
    const loadMoreText = loadMoreBtn.querySelector('[load-more-text]');
    const loader = loadMoreBtn.querySelector('[loader]');
    if (loadMoreText) loadMoreText.classList.add('hide');
    if (loader) loader.classList.remove('hide');

    const rawUrl = nextUrlInput.value;
    let nextUrl;
    if (window.location.pathname.startsWith('/collections')) {
      const baseUrl = rawUrl.split('?page=')[0];
      nextUrl = `${baseUrl}?page=${nextPage}`;
    } else {
      nextUrl = rawUrl.replace(/page=\d+/, `page=${nextPage}`);
    }

    fetch(nextUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(responseHTML => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(responseHTML, 'text/html');
        const newProducts = doc.querySelector('.ProductListWrapper .ProductList--grid.ProductList');
        const currentList = document.querySelector('.ProductListWrapper .ProductList--grid.ProductList');

        if (newProducts && currentList) {
          currentList.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        }

        currentPageInput.value = nextPage;

        if (nextPage < totalPages) {
          const newNextUrl = nextUrl.replace(/page=\d+/, `page=${nextPage + 1}`);
          nextUrlInput.value = newNextUrl;
        } else {
          loadMoreBtn.style.display = 'none';
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
      })
      .finally(() => {
        if (nextPage <= totalPages) {
          loadMoreBtn.disabled = false;
          if (loadMoreText) loadMoreText.classList.remove('hide');
          if (loader) loader.classList.add('hide');
        }
      });
  });


  
});
